import { alpha, typographyClasses } from '@mui/material'
import { colors } from '@/theme/colors.theme'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(() => {
  return {
    avatarContent: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '12px',

      '& .avatar': {
        height: 72,
        width: 72,
        backgroundColor: colors.darker,

        '& svg': {
          width: '100%',
          height: '100%',
        },
      },

      [`& .${typographyClasses.body1}`]: {
        fontSize: '19px',
        fontWeight: 700,
        color: colors.white,
      },

      [`& .${typographyClasses.body2}`]: {
        fontSize: '14px',
        color: colors.white,
        marginBottom: '5px',
      },

      '.inactive': {
        backgroundColor: colors.white,
        color: colors.black,
        '&:hover': {
          backgroundColor: alpha(colors.white, 0.5),
        },
      },

      '.active': {
        backgroundColor: colors.lighter,
        color: colors.primary,
        '&:hover': {
          backgroundColor: alpha(colors.lighter, 0.5),
        },
      },

      '.blocked': {
        backgroundColor: colors.redLight,
        color: colors.redDark,
        '&:hover': {
          backgroundColor: alpha(colors.redLight, 0.5),
        },
      },
    },
  }
})
